const pageSize = 10;

export { pageSize };
